<template>
  <div>
    <va-modal
      v-if="lead && list"
      :value="showModal"
      id="leadDetailsModal"
      ref="leadSummaryModal"
      :cancelText="$t('leads.back')"
      :okText="$t('modals.buttons.save')"
      size="large"
      :showOkay="isEditingLead"
      :ok-disabled="!canSubmitUpdate"
      @cancel="$emit('cancel')"
      @ok="handleLeadSave"
      :okToClose="false"
      :noOutsideDismiss="true"
      >

      <div slot="header" >
        <span class="modal-title">{{ $t('leads-web.details-modal.title') }}</span>
      </div>

      <div >
        <LeadCard :lead="lead" style="width: 30% !important;"/>
      </div>

      <hr class="separator-lead-details">

      <div id="lead-status-timeline">
        <LeadStatusTimeline :lead="lead" :canEdit="canEdit" :list="list" @lead-updated="handleLeadUpdated"/>
      </div>
      <hr class="separator-lead-details">

      <div id="lead-info-tab">
        <div class="tab-bar row">
          <div class="tab-button clickable" v-bind:class="{'selected-tab':selectedTab === 0}" @click="selectedTab=0">
            <span class="button-text">{{ $t('leads-web.details-modal.details') }}</span>
          </div>
          <div class="tab-button clickable" v-bind:class="{'selected-tab':selectedTab === 1}" @click="selectedTab=1">
            <span class="button-text">{{ $t('leads-web.details-modal.observations') }}</span>
          </div>
        </div>
        <div v-if="selectedTab===0">
          <LeadInfo

            ref="leadInfo"
            :lead="lead"
            :suppliers="suppliers"
            @editing-lead="handleIsEditingLead"
            @can-submit="handleCanSubmitUpdate"
            @lead-updated="handleLeadUpdated"
            :canEdit="canEdit"
            :readEntities="readEntities"
            :writableEntities="writableEntities"
          />

          <div v-if="leadContacts.length" style="margin-top: 35px; padding-left: 10px">
            <h6 class="is-bold">{{$t('leads-web.leads.everything')}}</h6>
            <ul class="StepProgress">
              <li v-for="leadContact in leadContacts" class="StepProgress-item">
                <div class="is-bold">{{leadContact.contactAction.name}}</div>
                <div class="label-text">{{ leadContact.createdAt | localTime}}</div>
              </li>
            </ul>
          </div>
        </div>
        <div v-if="selectedTab===1">
          <LeadObservations
            ref="leadObs"
            :lead="lead"
            :canEdit="canEdit"
          />
        </div>
      </div>

    </va-modal>

    </div>
</template>
<script>

import LeadCard from '@/components/leads-web/dashboard/LeadCard'
import LeadInfo from '@/components/leads-web/dashboard/LeadInfo'
import { LeadsWebService } from '@/api/LeadsWebService'
import { mapState } from 'vuex'
import LeadStatusTimeline from '@/components/leads-web/dashboard/LeadStatusTimeline'
import LeadObservations from '@/components/leads-web/dashboard/LeadObservations'

const TAB_DETAILS = 0
const TAB_OBSERVATIONS = 1

export default {
  components: {
    LeadObservations,
    LeadStatusTimeline,
    LeadInfo,
    LeadCard,
  },
  props: {
    canEdit: {
      type: Boolean,
      required: true,
      default: false
    },
    writableEntities: {
      type: Array,
      required: true
    },
    readEntities: {
      type: Array,
      required: true
    },
    lead: {
      type: Object,
      required: true
    },
    suppliers: {
      type: Array,
      required: true
    },
    list: {
      type: Array,
      required: true
    },
  },
  data () {
    return {
      showModal: false,
      leadContacts: [],
      isEditingLead: false,
      selectedTab: null,
      canSubmitUpdate: false
    }
  },
  created () {
    this.selectedTab = TAB_DETAILS
  },
  mounted () {
    this.getLeadContacts()
    this.showModal = true
  },
  methods: {
    handleCanSubmitUpdate (canSubmit) {
      this.canSubmitUpdate = canSubmit
    },
    handleLeadUpdated (lead) {
      this.isEditingLead = false
      this.canSubmitUpdate = false
      this.$emit('lead-updated', lead)
      this.showModal = false
    },
    handleIsEditingLead () {
      this.isEditingLead = !this.isEditingLead
    },
    handleLeadSave () {
      this.$refs.leadInfo.updateLead()
    },
    async getLeadContacts () {
      await LeadsWebService.getLeadContactsByLeadId(this.lead.id).then(res => {
        this.leadContacts = res.sort(function (a, b) {
          return new Date(b.createdAt) - new Date(a.createdAt)
        })
      })
        .catch(err => {
          console.log(err)
          this.showToast(this.$t('leads-web.leads.contacts-fetch-error'), this.$store.state.errorToastOptions)
        })
    }
  },
  computed: {
    ...mapState({
      'leadsWebToken': (state) => state.leadsWeb.leadsWebSrvToken
    }),
  },
}
</script>
<style lang="scss">
.va-modal{
  background-color: #f5f5f5 !important;
}
</style>
<style lang="scss" scoped>
.lead-card {
  width: 55% !important;
}

.tab-bar{

}
.selected-tab {
  background-color: #29C4AA !important;
  color: white !important;
}
.tab-button{
  background-color: white;
  color: #8c8c8c;
  height: 50px;
  width: 20%;
  text-align: center;
  display: flex;
  align-items:center;
  justify-content:center;
}

.label-text {
  color: #8c8c8c;
}

.StepProgress {
  position: relative;
  padding-left: 45px;
  list-style: none;
}
.StepProgress::before {
  display: inline-block;
  content: '';
  position: absolute;
  top: 5px;
  left: 30px;
  width: 10px;
  height: 80%;
  border-left: 2px solid #E5E5E5;
}
.StepProgress-item {
  position: relative;
  counter-increment: list;
}
.StepProgress-item:not(:last-child) {
  padding-bottom: 20px;
}
.StepProgress-item::before {
  display: inline-block;
  content: '';
  position: absolute;
  left: -20px;
  height: 100%;
  width: 10px;
}
.StepProgress-item::after {
  content: '';
  display: inline-block;
  position: absolute;
  top: 5px;
  left: -20px;
  width: 12px;
  height: 12px;
  border: 1px solid #E5E5E5;
  box-shadow: 0px 0px 12px #babfc2;
  border-radius: 50%;
  background-color: #FFF;
}
.StepProgress strong {
  display: block;
}

</style>
